import React from 'react';
import { motion } from 'framer-motion';
import { styled } from '@mui/joy/styles';
import { Logo } from 'assets';

const FadingLogoContainer = styled(motion.div)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
});

const LogoImage = styled(motion.img)({
  height: '80px',
});

export function FadingLogo() {
  return (
    <FadingLogoContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, ease: 'easeIn' }}
    >
      <LogoImage src={Logo} alt="Logo" />
    </FadingLogoContainer>
  );
}
